var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _line2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 170.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:none;}.cls-2,.cls-3{stroke:#d89f5b;stroke-width:2px;}.cls-2{stroke-linejoin:round;}.cls-3{stroke-linecap:round;stroke-miterlimit:10;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.74,25.9C22.54,6,46.27,15.73,52.34,20.3,47.62,26.59,26.38,42.91,12.74,25.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.7,25.34l30.2-4.27M12.74,25.9C22.54,6,46.27,15.73,52.34,20.3,47.62,26.59,26.38,42.91,12.74,25.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.64,24.5l5.53-7.35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.44,23.4l4.62-6.15m3,5.06,3.08-4.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.05,84.7C73.72,89.61,69.72,115,66.69,121.92,59.47,118.78,38.67,101.91,52.05,84.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.51,88.42,64.67,116.8M52.05,84.7C73.72,89.61,69.72,115,66.69,121.92,59.47,118.78,38.67,101.91,52.05,84.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.71,94l8.43,3.67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.59,101.33l7,3.07m-4.21,4.15,4.7,2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.1,49.44l8.73-2.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.14,53l7.3-2.42m-.38,5.9,4.87-1.61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.42,65.07a7.71,7.71,0,0,0,2.2-10.67,13,13,0,0,0-1.21-1.48A7.72,7.72,0,0,0,96,40.06a8.44,8.44,0,0,0-.77-1.53,7.68,7.68,0,0,0-14,5.71,8,8,0,0,0-4.08,1.25,7.7,7.7,0,0,0-2.21,10.66,7.85,7.85,0,0,0,5.5,3.45,7.52,7.52,0,0,0,1,6.41,7.7,7.7,0,0,0,10.66,2.2A7.25,7.25,0,0,0,94.85,65,7.68,7.68,0,0,0,103.42,65.07Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.35,59.18a1,1,0,0,0,1.39.29,1,1,0,0,0,.28-1.39,1,1,0,0,0-1.38-.28A1,1,0,0,0,98.35,59.18Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.9,47.45a1,1,0,0,0,1.38.29,1,1,0,0,0,.29-1.39,1,1,0,0,0-1.39-.28A1,1,0,0,0,98.9,47.45Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.27,59.77a7.69,7.69,0,1,1-14.75-.23"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.6,58.35a7.7,7.7,0,1,1-8.46-12.86,7.23,7.23,0,0,1,4.08-1.25"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84,48.77A6.66,6.66,0,0,1,82.31,47a7.7,7.7,0,1,1,12.87-8.46,10.14,10.14,0,0,1,.72,1.35"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.98,
    y1: 49.38,
    x2: 128.99,
    y2: 60.43
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.83,42.22c15.36-2.42,26,14.46,28.08,20.68C129,64.53,115.66,65.66,106.73,60"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.68,51a7.41,7.41,0,0,1,5.94,3.39A7.65,7.65,0,0,1,106.73,60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.73,60a7.66,7.66,0,0,1-3.31,5.07,7.83,7.83,0,0,1-8.52,0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.58,52.81a7.66,7.66,0,0,0,2.4-3.43"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.83,42.22c.12.15.23.29.34.45a7.67,7.67,0,0,1,.81,6.71"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.83,42.22A7.78,7.78,0,0,0,95.5,40.47a7.33,7.33,0,0,0-2.93,3.73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.13,51.24l3.76-2.47"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.81,50.15l-1.17-4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89,52.26l-4.46-.18"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.36,54l3,2.44"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.56,54.63,89,58.48"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.62,53.55a2.1,2.1,0,1,0,.6-2.91A2.1,2.1,0,0,0,89.62,53.55Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.91,43.31a1,1,0,0,0,1.39.28,1,1,0,0,0,.28-1.38,1,1,0,0,0-1.38-.29A1,1,0,0,0,87.91,43.31Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.53,52.47a1,1,0,0,0,1.39.28,1,1,0,0,0,.28-1.38,1,1,0,0,0-1.38-.29A1,1,0,0,0,80.53,52.47Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,62.33a1,1,0,0,0,1.38.28,1,1,0,0,0,.29-1.38,1,1,0,0,0-1.39-.29A1,1,0,0,0,87,62.33Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153,135c6.65-21.21,31.59-15.17,38.29-11.58C187.55,130.39,169.06,149.77,153,135Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.55,132.14l4.34-8.1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.09,129.86l3.63-6.77m3.79,4.53,2.42-4.52"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 159.9,
    y1: 132.94,
    x2: 186,
    y2: 125.05
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.15,132c8-17.55,30.76-12,37.12-8.55C188.69,128.27,179,139.05,168,140.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.15,132l-.76-.15c-4-.93-16.16-8.2-20.24,9.23-2.21,9.45,4,18,13.45,20.2s18.71-2.71,20.92-12.15a19.9,19.9,0,0,0,.43-8.84"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.15,132c1.51.25,3.62.41,5.75.93"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.9,132.94c3.47.85,7,2.66,8,7.36"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.79,135c2.27,2.59,8.39,4.53,11.39,2.67"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140,135.51c-3.61,3.57-4.19,9.08-3.1,13.24"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.82,141.24c-1.17,3.22-1.14,6.62.62,9.19"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.78,152.16c.3.48.69,1,1,1.47"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.93,125.9c1.81,4.12.83,8.31-.49,12.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1886c2e37b96bfa45e8036633f4551c0.svg";
export { ForwardRef as ReactComponent };